<script setup>
import { ref, useSlots } from "vue";
import { DialogDescription, DialogTitle } from "@headlessui/vue";
import Modal from "./Modal.vue";

defineProps({
    title: String,
    description: String,
    maxHeight: {
        type: [String, Number],
        default: undefined,
    },
});
defineEmits(["submit"]);

const modal = ref();

const slots = useSlots();

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

defineExpose({ show, hide });
</script>

<template>
    <Modal ref="modal" :class="[maxHeight !== undefined ? 'overflow-hidden' : '']">
        <div class="flex flex-col" :style="[maxHeight !== undefined ? 'max-height: ' + maxHeight + ';' : '']">
            <template v-if="!!slots.header">
                <slot name="header"></slot>
            </template>
            <template v-else-if="title || description">
                <div class="flex-none px-4 py-4 border-b border-gray-300 dark:border-gray-800 lg:px-8 sm:px-6">
                    <DialogTitle v-if="title" class="text-lg font-semibold leading-6 text-gray-900 dark:text-white">{{ title }}</DialogTitle>
                    <DialogDescription v-if="description" class="mt-1 text-sm text-gray-600 dark:text-gray-400">{{ description }}</DialogDescription>
                </div>
            </template>
            <form @submit.prevent="$emit('submit')" :class="['min-h-0 flex flex-col flex-1', maxHeight !== undefined ? 'overflow-y-hidden' : '']">
                <div :class="['flex-1 px-4 py-4 lg:px-8 sm:px-6', maxHeight !== undefined ? 'overflow-y-auto' : '']">
                    <slot name="body"></slot>
                </div>
                <div class="flex-none px-4 py-4 border-t border-gray-300 dark:border-gray-800 lg:px-8 sm:px-6">
                    <slot name="actions"></slot>
                </div>
            </form>
        </div>
    </Modal>
</template>
